//$('input[name="client_address"]').keyup(function() {

$('input[name="client_address"]').keyup(function () {

    var input = $(this);
    var meta_id = $(this).data('meta_id');
    console.log("meta_id");
    console.log(meta_id);
    var s = $(this).val();

    console.log(input.val());
    $(".suggestions-" + meta_id).remove();
    if (s.length > 8) {
        geocoder.geocode({
            'address': input.val(),
            componentRestrictions: { country: 'ES' }
        }, function (results, status) {
            if (status == 'OK') {
                $(".suggestions-" + meta_id).remove();
                input.after('<div class="suggestions-' + meta_id + '"><ul></ul></div>');
                for (var i = 0; i <= (results.length) - 1; i++) {
                    var utmObj = require('utm-latlng');
                    var utm = new utmObj();
                    var utmcalc = utm.convertLatLngToUtm(results[i].geometry.location.lat(), results[i].geometry.location.lng(), 1);
                    $(".suggestions-" + meta_id + " ul").append('<li><a data-index="' + i + '" data-meta_id="' + meta_id + '" href="javascript:loadAddressData(\'' + meta_id + '\',' + i + ')"></a></li>');
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").html(results[i].formatted_address);
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-client_address', results[i].formatted_address);
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-client_latitude_longitude', results[i].geometry.location.lat() + "," + results[i].geometry.location.lng());
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-client_zone', "what zona¿?");
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-client_utm_zone', utmcalc.ZoneNumber);
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-client_utm_east', utmcalc.Easting);
                    $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-client_utm_north', utmcalc.Northing);

                    for (var j = 0; j < results[i].address_components.length; j++) {
                        for (var k = 0; k < results[i].address_components[j].types.length; k++) {
                            if (results[i].address_components[j].types[k] == "postal_code") {
                                $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-location_postal_code', results[i].address_components[j].long_name);

                            }

                            const suggestion = $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]");
                            const componentType = results[i].address_components[j].types[k];
                            const isMunicipality = componentType === "locality";
                            const isMunicipalityFallback = [
                                "postal_town",
                                "administrative_area_level_3",
                                "administrative_area_level_4"
                            ].includes(componentType);

                            if (isMunicipality || (isMunicipalityFallback && !suggestion.attr('data-location_city_name'))) {
                                suggestion.attr('data-location_city_name', results[i].address_components[j].long_name);
                            }

                            if (results[i].address_components[j].types[k] == "street_number") {
                                $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-location_number', results[i].address_components[j].long_name);
                                console.log(results[i].address_components[j].long_name);
                            }

                            if (results[i].address_components[j].types[k] == "route") {
                                $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]").attr('data-location_street', results[i].address_components[j].long_name);
                                console.log(results[i].address_components[j].long_name);
                            }

                            if (
                                results[i].address_components[j].types[k] === "administrative_area_level_2"
                            ) {
                                $(".suggestions-" + meta_id + " ul li a[data-index=" + i + "]")
                                    .attr('data-location_province', results[i].address_components[j].long_name);
                            }
                                console.log(results[i].address_components);

                        }
                    }
                }
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
});
